import { useFonts } from 'expo-font'
import { useEffect, type PropsWithChildren, type ReactNode } from 'react'
import { View } from 'react-native'

import { AccessibilityProvider } from '@/src/features/accessibility/context/AccessibilityContext'
import { getLandingInfo, saveLandingInfo } from '@/src/general/utils/cookies/landingInfos'
import { initSessionInfo } from '@/src/general/utils/cookies/sessionInfo'
import { DevDimensions } from '@/src/general/utils/DevDimensions'

const QueryDevTools = () => {
  const { ReactQueryDevtools } = require('@tanstack/react-query-devtools')
  return <ReactQueryDevtools initialIsOpen={false} />
}

export const PlatformWrapper = ({ children }: PropsWithChildren): ReactNode => {
  // For the native side, fonts are loaded at build time
  useFonts({ Nunito: require('@/assets/fonts/Nunito-VariableFont_wght.ttf') })

  useEffect(() => {
    if (!getLandingInfo()) {
      saveLandingInfo({
        referrer: document.referrer,
        landingUrl: window.location.href,
        landingDate: new Date(),
      })
    }
    initSessionInfo()
  }, [])

  return (
    <AccessibilityProvider>
      {__DEV__ && <QueryDevTools />}
      <View className="flex-1 bg-transparent pb-safe-insets-b pt-safe-insets-t">{children}</View>
      <DevDimensions />
    </AccessibilityProvider>
  )
}
